export function setupVideoFallbackImage() {
    // Handle uploaded videos
    const uploadedVideos = document.querySelectorAll('[data-video="upload"] video');
    uploadedVideos.forEach(video => {
        const container = video.closest('[data-video="upload"]');
        const fallbackImages = container.querySelectorAll('.video-fallback-image-desktop, .video-fallback-image-mobile');

        // Function to show fallback images
        const showFallback = () => {
            fallbackImages.forEach(img => {
                img.classList.remove('d-none');
                if (img.classList.contains('video-fallback-image-desktop')) {
                    img.classList.add('d-none', 'd-md-block');
                } else {
                    img.classList.add('d-block', 'd-md-none');
                }
            });
        };

        // Show fallback on error
        video.addEventListener('error', showFallback);

        // Also check if video source fails to load
        const sources = video.querySelectorAll('source');
        sources.forEach(source => {
            source.addEventListener('error', showFallback);
        });

        // Check if video has valid duration after attempting to load
        video.addEventListener('loadedmetadata', () => {
            if (isNaN(video.duration) || video.duration === 0) {
                showFallback();
            }
        });

        // Timeout check - if video doesn't load properly within 3 seconds
        setTimeout(() => {
            if (video.readyState === 0 || isNaN(video.duration) || video.duration === 0) {
                showFallback();
            }
        }, 3000);
    });

    // Handle YouTube videos
    const youtubeIframes = document.querySelectorAll('[data-video="youtube"] iframe');
    youtubeIframes.forEach(iframe => {
        const container = iframe.closest('[data-video="youtube"]');
        const fallbackImages = container.querySelectorAll('.video-fallback-image-desktop, .video-fallback-image-mobile');

        // Show fallback on error
        iframe.addEventListener('error', () => {
            fallbackImages.forEach(img => {
                img.classList.remove('d-none');
                if (img.classList.contains('video-fallback-image-desktop')) {
                    img.classList.add('d-none', 'd-md-block');
                } else {
                    img.classList.add('d-block', 'd-md-none');
                }
            });
        });
    });

    // Handle embed videos
    const embedContainers = document.querySelectorAll('[data-video="embed"]');
    embedContainers.forEach(container => {
        const fallbackImages = container.querySelectorAll('.video-fallback-image-desktop, .video-fallback-image-mobile');

        // Handle embedded videos
        embedVideos.forEach(video => {
            video.addEventListener('error', () => {
                fallbackImages.forEach(img => {
                    img.classList.remove('d-none');
                    if (img.classList.contains('video-fallback-image-desktop')) {
                        img.classList.add('d-none', 'd-md-block');
                    } else {
                        img.classList.add('d-block', 'd-md-none');
                    }
                });
            });
        });

        // Handle embedded iframes
        embedIframes.forEach(iframe => {
            iframe.addEventListener('error', () => {
                fallbackImages.forEach(img => {
                    img.classList.remove('d-none');
                    if (img.classList.contains('video-fallback-image-desktop')) {
                        img.classList.add('d-none', 'd-md-block');
                    } else {
                        img.classList.add('d-block', 'd-md-none');
                    }
                });
            });
        });
    });
}



 export function handleVideoSrcSwitch() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    document.querySelectorAll('video source[data-mobile-src]').forEach(source => {
        const video = source.closest('video');
        const originalSrc = source.getAttribute('data-original-src') || source.getAttribute('src');
        const mobileSrc = source.getAttribute('data-mobile-src');

        // Store original src if not already stored
        if (!source.getAttribute('data-original-src')) {
            source.setAttribute('data-original-src', originalSrc);
        }

        if (isMobile && mobileSrc) {
            if (source.getAttribute('src') !== mobileSrc) {
                source.setAttribute('src', mobileSrc);
                if (video) video.load();
            }
        } else {
            if (source.getAttribute('src') !== originalSrc) {
                source.setAttribute('src', originalSrc);
                if (video) video.load();
            }
        }
    });
}